// extracted by mini-css-extract-plugin
export default {"listItemTick":"ListItemTick_listItemTick__8Hi2R","listItemTickIcon":"ListItemTick_listItemTickIcon__A7uve"};